import { MEDIA } from "@/data/media";
import { METHOD } from "@/data/content";
import { Reveal } from "@/components/Reveal";

export const MethodSection = () => {
  return (
    <section
      id="method"
      data-testid="method-section"
      className="section"
      style={{ backgroundColor: "var(--bg)" }}
    >
      <div className="container-fx">
        <div className="grid items-center gap-12 lg:grid-cols-2">
          {/* Left copy */}
          <Reveal>
            <div>
              <div className="flex items-center gap-3">
                <span
                  style={{
                    width: 40,
                    height: 1,
                    backgroundColor: "var(--bronze)",
                  }}
                />
                <p className="eyebrow">{METHOD.eyebrow}</p>
              </div>
              <h2
                className="display mt-6"
                style={{ fontSize: "clamp(2.4rem, 5.5vw, 4rem)", fontWeight: 500 }}
              >
                {METHOD.headline_lead}
                <br />
                <span className="accent-italic">{METHOD.headline_accent}</span>
              </h2>
              {METHOD.body.map((p, i) => (
                <p
                  key={i}
                  className="mt-5 max-w-xl"
                  style={{
                    color: "var(--text-2)",
                    fontSize: "0.98rem",
                    lineHeight: 1.7,
                  }}
                >
                  {p}
                </p>
              ))}
              <p
                className="eyebrow mt-8"
                style={{ color: "var(--muted)" }}
              >
                {METHOD.goal}
              </p>
            </div>
          </Reveal>

          {/* Right image */}
          <Reveal delay={0.15}>
            <div
              className="relative overflow-hidden"
              style={{
                borderRadius: "var(--radius-lg)",
                border: "1px solid var(--border-c)",
                aspectRatio: "4 / 5",
              }}
            >
              <img
                src={MEDIA.methodImage}
                alt="Athletic Pilates in motion"
                className="h-full w-full object-cover"
                loading="lazy"
              />
              <div
                className="absolute inset-0"
                style={{
                  background:
                    "linear-gradient(to top, rgba(11,10,8,0.6), rgba(11,10,8,0.05))",
                }}
              />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
